import { createContext, useEffect, useState } from "react";
import { validateSession } from "@/services/approveshield/api/auth";
import { getUser } from "@/services/approveshield/api/users";

export const AuthContext = createContext({ user: null });

export const AuthProvider = ({ children }) => {
  const [authenticating, setAuthenticating] = useState(true);
  const [user, setUser] = useState(null);

  const initAuth = async () => {
    setAuthenticating(true);
    try {
      const res = await validateSession();
      if (res.success) {
        const userRes = await getUser();
        setUser(userRes.data);
      } else {
        setUser(null);
      }
    } catch (error) {
      setUser(null);
    } finally {
      setAuthenticating(false);
    }
  }

  useEffect(() => {
    initAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        authenticating,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
